var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("My Preferences")]),_c('v-card-text',[_c('v-switch',{attrs:{"label":"Dark Theme","color":"purple"},model:{value:(_vm.$vuetify.theme.dark),callback:function ($$v) {_vm.$set(_vm.$vuetify.theme, "dark", $$v)},expression:"$vuetify.theme.dark"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }